import React from 'react';
import { Col, Row, Input, Label } from "reactstrap";
import {inject, observer} from "mobx-react";
import FormSelect from '../../../../comum/components/FormSelect';
import { IconeDelete } from '../../../../comum/components/Icones';
import SelectFiltro from "../../../../comum/components/SelectFiltro";
import FormInputSimples from "../../../../comum/components/FormInputSimples";
import FormInput from "../../../../comum/components/FormInput";
import Select from 'react-select';
import {statusNotaTranslate, setTemaSeletor, montarSelectOptionArray} from "../../../../../utils/formatar";
import _ from 'lodash';

@inject("store")
@observer
export default class CardNotaFiscalContainers extends React.Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = this.props.controller;
        this.listaBookings = [];
        this.listaContainers = [];

        this.state = { refresh: false};     

        this.isStatusPendente = _.get(this.props.container, 'Status')===undefined || _.get(this.props.container, 'Status')==='P';
        this.status = statusNotaTranslate(_.get(this.props.container, 'Status'));
    }

    getNumBooking = (event) =>{
        if(event){
            let selecionado  = this.props.listaContainersSelect.find(item => item.Index === event.value);
            return _.get(selecionado,`NumBooking`);
        }
        return '';
    };

    handleChangeContainersNF = (event, dado, notaPos, cntrIndex) => {
        this.props.setCamposContainer(event, dado, notaPos, cntrIndex);
    };

    handleOnChangeContainer = () => 
    {
        this.props.setDado(`${this.props.dado}.CodCntr`, event);
    }
    
    handleOnBlurContainer = () => 
    {
        this.props.validarContainerBookingNotas();
    }

    render() {
        return (
			this.appStore.isMobile()
            ? <Row>
                <SelectFiltro titulo={ "Container" } sm={12} md={12} itens={this.props.listaContainersSelect}
                    className="select"
                    valor={_.get(this.props.containersSelecionados,`[${this.props.notaIndex}][${this.props.index}]`)}
                    itensValor="Index"
                    itensLabel="CodCntr"
                    naoLimpar={true}
                    onChange={(event) => this.props.setCamposContainer(event, this.props.dado, this.props.notaIndex, this.props.index)}/>
                <Col sm={12} md={12} >
                    <Label>Booking</Label>
                    <Input disabled={true}
                        value={_.get(this.props.notaFiscal, 'Nf.NumNotaTransp') &&
                        this.getNumBooking(_.get(this.props.containersSelecionados,`[${this.props.notaIndex}][${this.props.index}]`))} />
                </Col>
                    <Col sm={12} md={12} >
                        <Input
                            disabled={true}
                            value={this.status ? this.status : ''}
                            onChange={() => this.props.setDado(`${this.props.dado}.Status`, 0)}/>
                    </Col>
            </Row>
            : <Row className="lacres">
                <Col className="card-form">                    
                    <Row className="mb-0 pb-0">                        
                        <Col sm={12} md={4} xl={4}>
                            <FormInput 
                                titulo="Container"  
                                sm={12} md={12}
                                bloqueado={false}
                                objeto={this.props.notaFiscal}
                                dado={`ListaCntr[${this.props.index}].CodCntr`}
                                onChange={(event) => this.handleOnChangeContainer(event)}  
                                onBlur={(event) => this.handleOnBlurContainer(event)}
                            />          
                        </Col> 
                        <Col sm={12} md={4} xl={4}>
                            <FormInput 
                                titulo="Booking"  
                                sm={12} md={12}
                                bloqueado={false}
                                objeto={this.props.notaFiscal}
                                dado={`ListaCntr[${this.props.index}].NumBooking`}
                                onChange={(event) => this.props.setDado(`${this.props.dado}.NumBooking`, event)}
                                onBlur={(event) => this.handleOnBlurContainer(event)}
                            />
                        </Col>
                        <Col sm={12} md={4} xl={4} >                        
                            <Label>Status</Label>
                            <Input
                                disabled={true}
                                value={this.status ? this.status : ''}
                                onChange={() => this.props.setDado(`${this.props.dado}.Status`, 0)}/>
                        </Col>
                    </Row>
                    { (!this.props.container.Status || this.props.container.Status===undefined || this.props.container.Status==='P')
                        && <IconeDelete className="mt-4 icone-delete-borda" tamanho="3x" onClick={ () => this.props.removeContainer(this.props.index) } />
                    }
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/CardNotaFistalContainers.js